<div class="post-header">
  <div class="post-header__info">
    <div class="post-header__department">
      <img src="assets/images/icons-svg/logo-black.svg" alt="logo" />

      <div class="post-header__department-text">
        @if (department) {
          <app-text
            [text]="department"
            [textType]="TextType.base"
            [textSize]="TextSizes.h5Post"
          ></app-text>
        }

        @if (city) {
          <app-text
            [textType]="TextType.base"
            [textSize]="TextSizes.h5Post"
            class="post-header__city"
          >
            <span>&nbsp;·&nbsp;</span>{{ city }}
          </app-text>
        }
      </div>
    </div>

    @if (date) {
      <app-text
        [text]="date | dateFormat: false : false : !utils.isDesktop"
        [textType]="TextType.base"
        [textSize]="TextSizes.date"
        class="post-header__date"
      ></app-text>
    }
  </div>

  <div class="post-header__user">
    <a
      class="post-user no-drag"
      (click)="!utils.isDesktop ? onNameClick() : undefined"
      [routerLink]="!utils.isDesktop ? link : null"
    >
      <div class="post-user__img" [class.post-user__img_border]="!avatar">
        <app-image [img]="avatar | addBaseUrl"></app-image>
      </div>

      <div>
        <a [routerLink]="utils.isDesktop ? link : null" class="nav-link post-user__name-link">
          @if (dateEmployment | yearsOfServiceBadgeIcon; as badgeIcon) {
            <app-svg [icon]="badgeIcon" class="post-user__years_of_service_badge"></app-svg>
          }
          @if (fullName) {
            <app-text
              [text]="fullName"
              class="post-user__name"
              [ngClass]="{ 'post-user__name_active': isActive }"
              [textType]="TextType.base"
              [textSize]="TextSizes.h4Name"
            ></app-text>
          }
        </a>

        @if (position) {
          <app-text
            [text]="position"
            class="post-user__position"
            [textType]="TextType.base"
            [textSize]="TextSizes.h5Post"
          ></app-text>
        }
      </div>
    </a>

    <div class="post-header__dropdown">
      <ng-content></ng-content>
    </div>
  </div>
</div>
